// extracted by mini-css-extract-plugin
export default {"pageLayout":"stripeCheckoutForm_pageLayout__sZ+nu"};